
export const html =`<div>
   <div style="background-color:white; width: 700px; height: 75px; margin:0 auto;">
       <!-- <img style="display: block; margin: 0 auto;"  height="75px" /> -->
   </div>
   <div style="width: 700px; margin:0 auto;">
       <div style="margin: 0 auto; background-color: #fbfbfb; padding: 27px;">
           <div>
                <div style="font-family: 'Fira Sans', sans-serif; font-size: 13px;">
                    <br />  
                    <div style="float: left; text-align: left; width: 50%">
                        <p style="text-align: center; font-family: 'Fira Sans', sans-serif;  font-size: 1.2rem; margin-top: 0; margin-bottom: 4%">
                            <h3>@subject </h3>
                        </p>
                        <br>
                    </div>
                    <div style="text-align: right; padding-bottom: 4%; float: right; width: 50%; padding-top: 2%;">
                        <h4 style="margin-top: 0;">@name</h4>
                        <span style="font-size:13px;">@street</span><br />
                        <span style="font-size:13px;">@city, @provinceState, @postalCode</span><br />
                        <span style="font-size:13px;">@phone</span><br />
                        <span style="font-size:13px;">@site</span>
                    </div>
                    <div style="clear: both;"></div>
                    <div>
                        <p>
                            @message
                        </p>
                    </div>

                    <div style="visibility: hidden"></div>
                    <div style="clear:both;"></div>
                </div>
           </div>
       </div>
   </div>
</div>`
